import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { debounceTime, Subject } from 'rxjs';
import { SlButtonComponent } from '../sl-button/sl-button.component';

@Component({
  selector: 'sl-search',
  standalone: true,
  imports: [CommonModule, FormsModule, SlButtonComponent],
  templateUrl: './sl-search.component.html',
  styleUrl: './sl-search.component.scss',
})
export class SlSearchComponent {
  @Input() id!: string;
  @Input() ariaLabel?: string;
  @Output() searchTextChangeEvent: EventEmitter<string> = new EventEmitter<string>();
  searchText = '';
  searchInput = new Subject<string>();

  constructor() {
    this.searchInput.pipe(debounceTime(400)).subscribe((value) => {
      this.searchTextChangeEvent.emit(value);
    });
  }
  changeValue() {
    this.searchInput.next(this.searchText);
  }

  clearSearch() {
    this.searchText = '';
    this.searchTextChangeEvent.emit(this.searchText);
  }
}
